<template>
    <div class="isBinding">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="头像/昵称">
                <template slot-scope="scope">
                    <div class="imgName">
                        <div class="imgBox">
                            <img :src="scope.row.clientheadimageurl" alt="">
                        </div>
                        <span>{{scope.row.clientnickname}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="totalordercount" label="累计订单数" class-name="center"></el-table-column>
            <el-table-column prop="totalordermoney" label="累计消费金额" class-name="center"></el-table-column>
            <el-table-column prop="bindtime" label="最新绑定时间" class-name="center"></el-table-column>
            <el-table-column prop="residue" label="剩余有效期" class-name="center"></el-table-column>
        </el-table>
        <Page ref="page" :total="total"></Page>
    </div>
</template>
<script>
import {bindUnbindList} from '@/api/extensionAgent'
import {mapGetters, mapActions} from 'vuex'
import Page from '@/base/page/page'
export default {
    name: 'isBinding',
    props: ['innerid'],
    data() {
        return {
            total: 200,
            tableData: [],
            params: {
                status: '1',
                innerid: ''
            }
        }
    },
    mounted() {
    },
    methods: {
        getList() {
            this.setLoading(true)
            bindUnbindList({
                data: Object.assign({}, this.params, this.$refs.page.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                    this.tableData.forEach(obj => {
                        let newTime, unbindTime, result
                        newTime = (new Date()).getTime()
                        unbindTime = obj.cancelbindtime
                        unbindTime = unbindTime.substring(0,19).replace(/-/g,'/')
                        unbindTime = new Date(unbindTime).getTime()
                        result = unbindTime - newTime
                        let days = parseInt(result / (24 * 60 * 60 * 1000))
                        obj.residue = days
                    })
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'innerid': {
            handler(newV) {
                if (newV) {
                    this.params.innerid = newV
                    this.getList()
                }
            }
        }
    },
    components: {
        Page
    }
}
</script>
<style lang="scss">
    .isBinding{
        .el-table{
            .imgName{
                display: flex;
                align-items: center;
                .imgBox{
                    width: 50px;
                    height: 50px;
                    margin-right: 6px;
                    img{
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                    }
                }
            }
            .center{
                .cell{
                    text-align: center;
                }
            }
        }
    }
</style>